<div [id]="chartId" [agprLoading]="loading" #chartElement class="agpr-reports-chart agpr-chart"></div>
